<template>
  <section class="section">
    <div class="content">
      <h1 class="subtitle">
        Greek Transliteration &amp; Gematria
      </h1>

      <p>
        <back-button />
      </p>
    </div>

    <div class="columns">
      <div class="column is-4">
        <div class="field">
          <label class="label">Transliteration to Latin Characters</label>
          <div class="control">
            <input class="input" v-model="transliteration">
          </div>
        </div>

        <div class="field">
          <label class="label">Greek Characters</label>
          <div class="control">
            <input class="input" readonly v-model="greek">
          </div>
        </div>

        <div class="field">
          <label class="label">Gematria Value</label>
          <div class="control">
            <input class="input" readonly v-model="gematria">
          </div>
        </div>

        <div class="field">
          <label class="checkbox">
            <input type="checkbox" v-model="sigmaTauBecomesDigamma">
            Consider στ ligature as <a target="_blank" href="https://en.wikipedia.org/wiki/Digamma#Conflation_with_the_%CF%83%CF%84_ligature">stigma</a>
          </label>
        </div>
      </div>

      <div class="column is-8">
        <div class="keyboard buttons has-addons is-centered">
          <button v-for="letter in letters" :key="letter.abbr" v-if="letter.show" :title="letter.name" class="button" @click="append(letter)">
            <strong>{{ letter.greek }}</strong>
            {{ letter.name }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gematriaEquation, transliterationToGreek, greekLetters } from '@/greek'
import BackButton from '@/components/pages/BackButton'

export default {
  components: {
    BackButton
  },
  computed: {
    greek () {
      return transliterationToGreek(this.transliteration)
    },
    gematria () {
      return gematriaEquation(this.greek, { sigmaTauBecomesDigamma: this.sigmaTauBecomesDigamma })
    }
  },
  watch: {
    transliteration (newValue) {
      const query = {
        q: newValue,
        sigmaTauBecomesDigamma: this.sigmaTauBecomesDigamma
      }
      this.$router.replace({
        name: 'greek_transliteration',
        query
      })
    },
    sigmaTauBecomesDigamma (newValue) {
      const query = {
        q: this.transliteration,
        sigmaTauBecomesDigamma: newValue
      }
      this.$router.replace({
        name: 'greek_transliteration',
        query
      })
    }
  },
  data () {
    return {
      transliteration: '',
      letters: greekLetters,
      sigmaTauBecomesDigamma: true
    }
  },
  methods: {
    append (letter) {
      this.transliteration += letter.abbr
    }
  },
  mounted () {
    this.transliteration = (this.$route.query.q || '')
    this.sigmaTauBecomesDigamma = (this.$route.query.sigmaTauBecomesDigamma || true)
  }
}
</script>

<style lang="sass" scoped>
.textarea
  min-height: 5em
  max-height: 5em

.keyboard
  .button
    strong
      margin-right: 0.75rem

@media (min-width: 768px)
  .keyboard
    .button
      height: 3em

      strong
        font-size: 1.5em

@media (min-width: 1024px)
  .keyboard
    .button
      height: 4em

      strong
        font-size: 2em
</style>



// WEBPACK FOOTER //
// src/components/pages/GreekTransliterationPage.vue